export default __webpack_public_path__ + "static/media/coachesOnboarding.ceb214b0.jpg";